import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {ContentType, request} from 'utils/request';

type SetLangSuccessResponse = Api.Response.Success<{
    language: string;
}>;

type SetLangErrorResponse = Api.Response.Failure;

type SetLangRequestRequest = {
    language: string;
};

const usePostSetLang = (): UseMutationResult<
    SetLangSuccessResponse,
    SetLangErrorResponse,
    SetLangRequestRequest
> => {
    const locale = useLocale();

    return useMutation((formData) =>
        request({
            contentType: ContentType.FORM_URLENCODED,
            formData,
            locale,
            method: 'POST',
            uri: '/i18n/setlang/',
        }),
    );
};

export default usePostSetLang;
